import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useI18n } from '../i18n/I18nProvider';

const LABELS = {
  en: 'English',
  af: 'Afrikaans',
  zu: 'isiZulu',
};

const LanguageSwitcher = ({ compact = false }) => {
  const { language, changeLanguage, supportedLanguages, t } = useI18n();

  return (
    <FormControl size="small" sx={{ minWidth: compact ? 110 : 140 }}>
      <InputLabel id="language-select-label">{t('language', 'Language')}</InputLabel>
      <Select
        labelId="language-select-label"
        value={language}
        label={t('language', 'Language')}
        onChange={(event) => changeLanguage(event.target.value)}
        inputProps={{ 'aria-label': t('language', 'Language') }}
      >
        {supportedLanguages.map((lang) => (
          <MenuItem key={lang} value={lang}>
            {LABELS[lang] || lang.toUpperCase()}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher;
